import _ from "lodash"
import { useEffect, useMemo, useRef, useState } from "react"

export const useAsyncSearch = <T extends Record<string, any>>(
  asyncRefetch?: (searchQuery?: string) => Promise<T[]>,
  options?: { label: string; value: string }[]
) => {
  const [searchValue, setSearchValue] = useState("")
  const inputRef = useRef<HTMLInputElement>(null)

  const debouncedSearch = useMemo(
    () =>
      _.debounce(async (query: string) => {
        if (asyncRefetch) {
          try {
            await asyncRefetch(query)
            inputRef.current?.focus()
          } catch (error) {
            console.error(error)
          }
        }
      }, 100),
    [asyncRefetch]
  )

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [options])

  useEffect(() => {
    if (searchValue === "") {
      asyncRefetch?.("")
    }
    if (searchValue && asyncRefetch) {
      debouncedSearch(searchValue)
    }
    return () => {
      debouncedSearch.cancel()
    }
  }, [searchValue, debouncedSearch, asyncRefetch])

  return {
    searchValue,
    setSearchValue,
    inputRef,
  }
}
